export const app_version = "v 1.0.0.14";
export const durations = [
    { "value": "2025", "label": "FY 2025-2026" },
    { "value": "2024", "label": "FY 2024-2025" },
    { "value": "2023", "label": "FY 2023-2024" },
    { "value": "2022", "label": "FY 2022-2023" },
    { "value": "2021", "label": "FY 2021-2022" },
    { "value": "2020", "label": "FY 2020-2021" },
    { "value": "2019", "label": "FY 2019-2020" },
    { "value": "2018", "label": "FY 2018-2019" },
    { "value": "0"   , "label": "Today" },
    { "value": "1"   , "label": "Yesterday" },
    { "value": "2"   , "label": "This Week" },
    { "value": "3"   , "label": "Last Week" },
    { "value": "4"   , "label": "This Month" },
    { "value": "5"   , "label": "Last Month" },
    { "value": "6"   , "label": "Last 2 Month" },
    { "value": "7"   , "label": "Last 3 Month" },
    { "value": "8"   , "label": "Last Year" },
    { "value": "9"   , "label": "Last 1 Year" }
]

export const clearCache = () => {
    caches.keys().then(function(names) {
        for (let name of names)
            caches.delete(name);
    });
    setTimeout(() => window.location.reload(), 5000);
}

export const getDurations = () => {
    let durations: { value: string; label: string }[] = [];
    durations = getFinancialYears();

    durations.push({ value: "0"   , label: "Today" });
    durations.push({ value: "1"   , label: "Yesterday" });
    durations.push({ value: "2"   , label: "This Week" });
    durations.push({ value: "3"   , label: "Last Week" });
    durations.push({ value: "4"   , label: "This Month" });
    durations.push({ value: "5"   , label: "Last Month" });
    durations.push({ value: "6"   , label: "Last 2 Month" });
    durations.push({ value: "7"   , label: "Last 3 Month" });
    durations.push({ value: "8"   , label: "Last Year" });
    durations.push({ value: "9"   , label: "Last 1 Year" });

    return durations;
}

export const getFinancialYears = () => {
    const durations: { value: string; label: string }[] = [];
    let financialYear = getCurrentFinancialYear();
    for (let i = 0; i < 5; i++) {
        durations.push({ value: financialYear.toString(), label: `FY ${financialYear}-${financialYear + 1}` });
        financialYear -= 1;
    }

    return durations;
}

export const getCurrentFinancialYear = () => {
    let financialYear = new Date().getFullYear();
    if (new Date().getMonth() < 3) {
        financialYear = financialYear - 1;
    }
    return financialYear;
}
